import React from 'react'
import { Link } from 'react-router-dom'
import H3 from "@material-tailwind/react/Heading3";
import '../CSS/Select_Cate.css'

const Select_Cate = () => {
    return (
        <div className="select_cate">
            <div className="select_cateSubDiv">
                <H3>Select Category</H3>

                <Link to='/Counsellors_page'>

                    <div className="categories">
                    
                        <img src="https://serefe.s3.amazonaws.com/media/service/2.png" alt="" />
                        <img src="https://serefe.s3.amazonaws.com/media/service/14.png" alt="" />
                        <img src="https://serefe.s3.amazonaws.com/media/service/4.png" alt="" />
                        <img src="https://serefe.s3.amazonaws.com/media/service/3.png" alt="" />
                        <img src="https://serefe.s3.amazonaws.com/media/service/1.png" alt="" />
                        <img src="https://serefe.s3.amazonaws.com/media/service/5.png" alt="" />
                        <img src="https://serefe.s3.amazonaws.com/media/service/6.png" alt="" />
                        <img src="https://serefe.s3.amazonaws.com/media/service/15.png" alt="" />
                        <img id='hideOn468px' src="https://serefe.s3.amazonaws.com/media/service/12.png" alt="" />
                    </div>
                    
                </Link>

            </div>
        </div>
    )
}

export default Select_Cate;
